import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { Étape } from '../référentiel-métier-parcours/models/étape.model';
import { EtapeService } from '../référentiel-métier-parcours/parcours-etape/parcours-etape.service';
import { EtapeStore } from '../référentiel-métier-parcours/parcours-etape/store/etape.store';

export const etapeResolver: ResolveFn<Observable<Étape> | undefined> = (route) => {
  const etapeService = inject(EtapeService);
  const etapeStore = inject(EtapeStore);
  const id = route.queryParamMap.get('id');
  const type = route.queryParamMap.get('type');

  if (!id || type != 'étape') {
    return undefined;
  }

  return etapeService.trouveParId(id).pipe(
    tap((etape) => {
      etapeStore.ajouterEtape({ etape });
      etapeStore.select({ id: etape.id });
    }),
  );
};
